import React from "react";
import classNames from "classnames";

interface RadioGroupProps {
  label: string;
  options: { label: string; value: string | number }[];
  value: string | number;
  onChange: (value: string | number) => void;
  className?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  options,
  value,
  onChange,
  className,
}) => {
  return (
    <div className={classNames("flex flex-col gap-2 w-full", className)}>
      <label className="text-gray-700 font-medium">{label}</label>
      <div className="flex gap-4">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center gap-2 cursor-pointer"
          >
            <input
              type="radio"
              value={option.value}
              checked={value.toString() === option.value.toString()}
              onChange={() => onChange(option.value)}
              className="accent-primary w-4 h-4"
            />
            <span className="text-gray-600">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
